// Third Party Library
import { useState, useEffect } from "react";
import { Card, Row, Col, Image, Skeleton } from "antd";
import { useDispatch, useSelector, batch } from "react-redux";

// Constants

// Redux
import { REDUX as REDUX_UTIL } from "../../services/util";
import * as REDUX_ACTION from "../../services/redux/actions";
import { ROOT_CONSTANT, TEMPLATE } from "../../constants";

// Components
import { DailyStatistics, EmployeeSubmission, MonthlyStatistics, TopCompanies } from "./components";

// Handlers
import { dashboardHDLR } from "../../handlers";

//services

// styles
import "../index.module.css";
import "./index.css";

const { reduxStoreWrapper } = REDUX_UTIL;

const { 
  icon_dashboard_processing,
  icon_dashboard_publishing,
  icon_dashboard_repayment,
  icon_dashboard_company, 
  icon_dashboard_active_employee,
} = ROOT_CONSTANT.IMG.ICON.DASHBOARD;

const { SELECT_OPTION_DAYS, SELECT_OPTION_YEARS } = TEMPLATE.DASHBOARD

const Dashboard = () => {
  const dispatch = useDispatch();


  const user = useSelector(reduxStoreWrapper("user"));
  const company = useSelector(reduxStoreWrapper("company.byID"));

  const topDashboard = useSelector(reduxStoreWrapper("dashboard.all.dashboard"));
  const daily = useSelector(reduxStoreWrapper("dashboard.daily"));
  const loadingAll = useSelector(reduxStoreWrapper("style.loading.dashboardAll"));
  const loadingDaily = useSelector(reduxStoreWrapper("style.loading.dashboardDaily"));
  const loadingMonthly = useSelector(reduxStoreWrapper("style.loading.dashboardMonthly"));

  const {uroleid, coid} = user
  const {total_active_companies, total_all_employee_activate, summaries} = daily
  const totalCompaniesActive = total_active_companies
  const totalEmployeeActive = total_all_employee_activate

  useEffect(() => {
    if (uroleid === "EMR") {
      dispatch(
        REDUX_ACTION.v1_company.get_company_thru_coid_request(coid)
      );
    } else {
      if(uroleid === "A" && summaries.length === 0){
        batch(() => {
          dispatch(REDUX_ACTION.v1_company.get_all_company_request());
          dispatch(REDUX_ACTION.v1_dashboard.get_all_dashboard_request());
          dispatch(REDUX_ACTION.v1_dashboard.get_dashboard_timeframe_daily_thru_90days_request());
          dispatch(REDUX_ACTION.v1_dashboard.get_dashboard_timeframe_monthly_thru_90days_request());
        });
      }
    }
    return () => {};
  }, [dispatch, uroleid]);

 
  return (
    <div className="container-db">
      <Row style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
        <Col style={{width: "19%", marginBottom: "10px"}}>
          <Card className="card-radius card-shadow">
            <Row className="row-space">
              <Col className="background-icon" style={{backgroundColor: "#0E2483"}}>
                <Image src={icon_dashboard_processing} alt="processing" width={20} height={20}/>
              </Col>
              <Col>
                {loadingAll ? (
                  <Skeleton.Button active size={20} shape="default" block={false} />
                ) : (
                  <Row className="title">{topDashboard.totalAwaitingProcess || 0}</Row>
                )}
                <Row className="sub-title">Awaiting Processing</Row>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col style={{width: "20%", marginBottom: "10px"}}>
          <Card className="card-radius card-shadow">
            <Row className="row-space">
              <Col className="background-icon" style={{backgroundColor: "#821CB1"}}>
                <Image src={icon_dashboard_publishing} alt="processing" width={20} height={20}/>
              </Col>
              <Col>
                {loadingAll ? (
                  <Skeleton.Button active size={20} shape="default" block={false} />
                ) : (
                  <Row className="title">{topDashboard.totalInvoceAwaitingPublishing || 0}</Row>
                )}
                <Row className="sub-title">Invoice Awaiting Publishing</Row>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col style={{width: "19%", marginBottom: "10px"}}>
          <Card className="card-radius card-shadow">
            <Row className="row-space">
              <Col className="background-icon" style={{backgroundColor: "#5454C5"}}>
                <Image src={icon_dashboard_repayment} alt="amount" width={20} height={20}/>
              </Col>
              <Col>
                {loadingAll ? (
                  <Skeleton.Button active size={20} shape="default" block={false} />
                ) : (
                  <Row className="title">RM {topDashboard.totalPendingRepayment || 0}</Row>
                )}
                <Row className="sub-title">Pending Repayment</Row>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col style={{width: "19%", marginBottom: "10px"}}>
          <Card className="card-radius card-shadow">
            <Row className="row-space">
              <Col className="background-icon" style={{backgroundColor: "#FFA800"}}>
                <Image src={icon_dashboard_company} alt="company" width={20} height={20}/>
              </Col>
              <Col>
                {loadingDaily ? (
                  <Skeleton.Button active size={20} shape="default" block={false} />
                ) : (
                  <Row className="title">{totalCompaniesActive}</Row>
                )}
                <Row className="sub-title">Active Companies</Row>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col style={{width: "19%", marginBottom: "10px"}}>
          <Card className="card-radius card-shadow">
            <Row className="row-space">
              <Col className="background-icon" style={{backgroundColor: "#FF5900"}}>
                <Image src={icon_dashboard_active_employee} alt="active" width={20} height={20}/>
              </Col>
              <Col>
                {loadingDaily ? (
                  <Skeleton.Button active size={20} shape="default" block={false} />
                ) : (
                  <Row className="title">{totalEmployeeActive}</Row>
                )}
                <Row className="sub-title">Active Employees</Row>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row style={{marginTop: "2%"}} gutter={12}>
        <Col span={13}>
          <DailyStatistics 
            items={SELECT_OPTION_DAYS}
            selection={dashboardHDLR.SelectCompanies(company)}
            loading={loadingDaily}
          />
        </Col>
        <Col span={11}>
          <TopCompanies 
            items={SELECT_OPTION_DAYS}
            loading={loadingDaily}
          />
        </Col>
      </Row>

      <Row style={{marginTop: "2%"}} gutter={12}>
        <Col span={13}>
          <MonthlyStatistics
            selection={dashboardHDLR.SelectCompanies(company)}
            loading={loadingMonthly}
          />
        </Col>
        <Col span={11}>
            <EmployeeSubmission 
              items={SELECT_OPTION_DAYS}
              selection={dashboardHDLR.SelectCompanies(company)}
              loading={loadingDaily}
            />
        </Col>
      </Row>
      <div style={{margin: "50px", color: "white"}}>Space</div>
    </div>
  );
};
export default Dashboard;